import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { resolveCurrencyDisplayName } from '../shared/utils/currency-name.util';

@Pipe({
  name: 'currencyName',
  pure: false,
})
export class CurrencyNamePipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}

  transform(
    code: string | null | undefined,
    fallback?: string | null,
  ): string {
    return resolveCurrencyDisplayName(this.translate, code, fallback);
  }
}
